/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index list to autogenerate all the components and extensions
 * Used by "prepareLists"
 */

import List from './list/List'
export * from './list/List'
export default List
